import {
  ParagraphText,
  StackLayout,
  TextAction,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useExternalLinks } from 'hooks/use-external-links/use-external-links.hook';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';

export const SignInFooter = () => {
  const { formatMessage } = useIntl();
  const { systemId } = usePatientPortalContext();
  const externalLinks = useExternalLinks();

  const isMyHealth = systemId === PATIENT_PORTAL_SYSTEM_IDS.MY_HEALTH;

  if (isMyHealth) {
    if (!externalLinks.PRIVACY_POLICY) return null;

    return (
      <StackLayout
        horizontalAlignment="center"
        css={{ position: 'relative', marginBlockStart: '$one', width: '100%' }}
      >
        <ParagraphText size="sm">
          <TextAction
            href={externalLinks.PRIVACY_POLICY}
            target="_blank"
            rel="noopener noreferrer"
            size="medium"
            css={{ textDecoration: 'underline' }}
          >
            {formatMessage({ id: 'STR_PRIVACY_POLICY' })}
          </TextAction>
        </ParagraphText>
      </StackLayout>
    );
  }

  if (
    !externalLinks.PRIVACY_COLLECTION_NOTICE &&
    !externalLinks.TERMS_OF_SERVICE
  )
    return null;

  return (
    <StackLayout
      horizontalAlignment="center"
      css={{ position: 'relative', marginBlockStart: '$one', width: '100%' }}
    >
      <ParagraphText size="sm">
        {externalLinks.PRIVACY_COLLECTION_NOTICE && (
          <TextAction
            href={externalLinks.PRIVACY_COLLECTION_NOTICE}
            target="_blank"
            rel="noopener noreferrer"
            size="medium"
            css={{ textDecoration: 'underline' }}
          >
            {formatMessage({ id: 'STR_COLLECTION_NOTICE' })}
          </TextAction>
        )}

        {externalLinks.TERMS_OF_SERVICE && (
          <>
            {externalLinks.PRIVACY_COLLECTION_NOTICE &&
              ` ${formatMessage({ id: 'STR_AND' })} `}
            <TextAction
              href={externalLinks.TERMS_OF_SERVICE}
              target="_blank"
              rel="noopener noreferrer"
              size="medium"
              css={{ textDecoration: 'underline' }}
            >
              {formatMessage({ id: 'STR_TERMS_OF_SERVICE' })}
            </TextAction>
          </>
        )}
      </ParagraphText>
    </StackLayout>
  );
};
